import { get } from "lodash";
import { SUBSCRIPTION_TEMPLATES, TEMPLATE_TYPES } from "utils/constants";
import Templates from "./Templates";

const ACORIS_PROCESS_TEMPLATES = [
  TEMPLATE_TYPES.B2B_ACORIS,
  TEMPLATE_TYPES.B2C_ACORIS,
];

export const resolveSubscriptionTemplate = ({
  processTemplate,
  organizationTemplate,
} = {}) => {
  const isAcorisOrganization =
    SUBSCRIPTION_TEMPLATES[organizationTemplate] ===
    SUBSCRIPTION_TEMPLATES.ACORIS;
  if (
    ACORIS_PROCESS_TEMPLATES.includes(processTemplate) ||
    isAcorisOrganization
  ) {
    return Templates.Acoris;
  }
  return get(
    Templates,
    SUBSCRIPTION_TEMPLATES[organizationTemplate],
    Templates.Health,
  );
};
